import React, { useState, useEffect } from 'react';
import { Upload } from 'antd';
import { PlusOutlined, LoadingOutlined, FilePdfOutlined } from '@ant-design/icons';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {nanoid} from 'nanoid';



export default (props) => {
	let { record, setRecord, name, disabled, fileName } = props;
	let [file, setFile] = useState([]);
	let [imageUrl, setImageUrl] = useState(false);
	let [loading, setLoading] = useState(false)
	let [uploadStart, setUploadStart] = useState(false)

	const storage = getStorage();

	useEffect(() => {
		if (record[name]) {
			setImageUrl(record[name].url);
		}
	}, []);

	let handleChange = info => {
		if (!info.event && uploadStart === false) {
			setUploadStart(true)
			const storageRef = ref(storage, fileName + "/" + info.file.originFileObj.name);
			const metadata = {
				contentType: 'image/jpeg',
			};
			uploadBytes(storageRef, info.file.originFileObj, metadata).then((snapshot) => {
				getDownloadURL(ref(storage, fileName + "/" + info.file.originFileObj.name))
					.then((url) => {
						let format = {
							id: nanoid(20),
							url: url,
							thumb: url,
							type: "image",
							mimeType: metadata.contentType
						}
						setFile(format);
						setRecord({
							...record, [name]: format
						})
						setImageUrl(url);
						setUploadStart(false)
						setLoading(false);
					})
					.catch((error) => {
						// Handle any errors
					});
			});
		}
	};

	let beforeUpload = () => {
		setImageUrl(false)
		setLoading(true);
	}
	const uploadButton = (
		<div  >
			{loading ? <LoadingOutlined /> : <PlusOutlined />}
			<div style={{ marginTop: 8 }}>Upload</div>
		</div>
	);

	if (name == "pdf") {
		return <>
			<Upload
				name={name}
				listType="picture-card"
				className="avatar-uploader"
				showUploadList={false}
				beforeUpload={beforeUpload}
				onChange={handleChange}
				disabled={disabled}
			>

				{imageUrl ? <FilePdfOutlined style={{ fontSize: '50px' }} /> : uploadButton}

			</Upload>
		</>
	}
	else {
		return <>
			<Upload
				name={name}
				listType="picture-card"
				className="avatar-uploader"
				showUploadList={false}
				beforeUpload={beforeUpload}
				onChange={handleChange}
				disabled={disabled}
			>
				{imageUrl ? <img src={imageUrl} alt={name} style={{ width: '100%', height: 'inherit', objectFit: 'contain' }} /> : uploadButton}
			</Upload>
		</>
	}
};
